import {
  Document,
  Page,
  View,
  Text,
  Image,
  StyleSheet,
  Font,
  Link,
  
} from "@react-pdf/renderer";

import imgKkp from "../../assets/img/logo-kkp.png";
import srcArial from "../../assets/font/arial/arial.ttf";
import srcArialBold from "../../assets/font/arial/ARIBL0.ttf";
import scheduleService from "services/report/scheduleService";
import LampPersonil from "./LampPersonil";
import LampProduk from "./LampProduk";

// REGISTER FONT (GLOBAL, SEKALI)
Font.register({ family: "Arial", src: srcArial });
Font.register({ family: "Arial-Bold", src: srcArialBold });
Font.registerHyphenationCallback(word => [word]);


// =====================
// STYLES
// =====================
const styles = StyleSheet.create({
  page: {
    paddingTop: 20,
    paddingBottom: 30,
    paddingHorizontal: 42,
    fontFamily: "Arial",
    fontSize: 12,
    lineHeight: 1.2,
  
  },

    row: {
      flexDirection: "row",
      alignItems: "flex-start",
    },

  center: { textAlign: "center" },

  bold: { fontFamily: "Arial-Bold" },

  logo: { width: 120, height: 120 },

  headerLine: {
    borderBottomWidth: 2,
    borderBottomColor: "#000",
    marginBottom: 6,
    paddingBottom: 4,
  },

  section: { marginBottom: 3 },

  labelCol: { width: "16%" },
  colonCol: { width: "2%" },
  numberCol: { width: "4%" },
  contentCol: {
    width: "80%",
    fontSize: 12,
    textAlign: "justify",
    lineHeight: 1.4,
  },

  tableHeader: {
    borderWidth: 1,
    borderColor: "#000",
    padding: 4,
    fontFamily: "Arial-Bold",
    textAlign: "center",
  },

  cell: {
    borderBottomWidth: 1,
    borderRightWidth: 1,
    borderColor: "#000",
    padding: 4,
    minHeight: 22,
    textAlign: "center",
    justifyContent: "center",
  },
  justifyIndent: {
    textAlign: "justify",
    textIndent: 20,
    lineHeight: 1.4,
  },
  penutup: {
    marginTop: 1,
    textAlign: "justify",
    lineHeight: 1.4,
  },

  footerRow: {
    marginTop: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },

  kknBox: {
    marginTop: 10,
    width: "45%",
    borderWidth: 1,
    padding: 8,
  },

  kknText: {
    fontSize: 11,
    textAlign: "center",
    fontFamily: "Arial-Bold",
    lineHeight: 1.2,
    textAlign: "justify", 
  },

  ttd: {
    width: "40%",
    alignItems: "left",
  },

  jabatanText: {
    marginTop: 5,
  },

  namaPejabat: {
    marginTop: 50,
      },

  fieldRow: {
  flexDirection: "row",
  alignItems: "flex-start",
},

fieldLabel: {
  width: 45, // samakan semua label
},

fieldColon: {
  width: 6,
},

fieldValue: {
  flex: 1,
},


});
const formatTanggal = (tanggal) => {
  if (!tanggal) return "";
  return new Date(tanggal).toLocaleDateString("id-ID", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};
const getSelisihHari = (tglMulai, tglSelesai) => {
  if (!tglMulai || !tglSelesai) return "1 (Satu)"; // Default 1 hari jika tanggal tidak lengkap

  const start = new Date(tglMulai);
  const end = new Date(tglSelesai);

  const diffInMs = Math.abs(end - start);
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24)) + 1;

  const terbilang = ["Nol", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan", "Sepuluh"];
  
  const teksTerbilang = terbilang[diffInDays] || "Banyak";

  return `${diffInDays} (${teksTerbilang})`;
};

const STInspeksi = ({ data }) => {
  if (!data) return null;

  const {
    no_surat,
    tanggal_surat,
    pejabat_ttd,
    jadwal = [],
  } = data;

  const jadwalUtama = jadwal[0] || {};
  const personil = jadwalUtama.personil || [];
  const produk = jadwalUtama.produk || [];

  const isTerlampir = personil.length > 2;

  return (
    <Document>
      {/* ================= PAGE 1 ================= */}
      <Page size="A4" style={styles.page}>
        {/* HEADER */}
        <View style={[styles.row, styles.headerLine]}>
          <Image src={imgKkp} style={styles.logo} />
          <View style={{ flex: 1, alignItems: "center" }}>
            <Text style={[styles.bold, { fontSize: 14, color: "#7895be" }]}>
              KEMENTERIAN KELAUTAN DAN PERIKANAN
            </Text>
            <Text style={{  fontSize: 13, color: "#7895be" }}>
              BADAN PENGENDALIAN DAN PENGAWASAN MUTU
            </Text>
            <Text style={{  fontSize: 13, color: "#7895be" }}>
              HASIL KELAUTAN DAN PERIKANAN
            </Text>
            <Text style={[styles.bold, { fontSize: 12, color: "#7895be" }]}>
              BALAI PENGENDALIAN DAN PENGAWASAN MUTU,
            </Text>
            <Text style={[styles.bold, { fontSize: 12, color: "#7895be" }]}>
              DAN KEAMANAN HASIL PERIKANAN JAKARTA
            </Text>
            <Text style={{  fontSize: 11, color: "#000000ff" }}>
              GEDUNG KARANTINA PERTANIAN BANDARA SOEKARNO-HATTA 19120  
            </Text>
            <Text style={{  fontSize: 11, color: "#000000ff" }}>
              TELEPON (021) 5507932, 22566785 FAKSIMILE (021) 5506738  
            </Text>
            <Text style={{  fontSize: 11, color: "#000000ff" }}>
                LAMAN{" "}
                <Link 
                    src="https://www.kkp.go.id" 
                    style={{ color: "blue", textDecoration: "underline" }}
                >
                    www.kkp.go.id
                </Link>
                {" "} SURAT ELEKTRONIK {" "}
                <Link 
                    src="JakartaI@bkipm.kkp.go.id" 
                    style={{ color: "blue", textDecoration: "underline" }}
                >
                    jakartaI@bkipm.kkp.go.id
                </Link>
            </Text>
          </View>
        </View>

        {/* JUDUL */}
        <View style={styles.section}>
          <Text style={[styles.center]}>SURAT TUGAS
          </Text>
          <Text style={styles.center}>
           Nomor: {no_surat}
          </Text>
        </View>

        {/* MENIMBANG */}
        <View style={styles.section}>
          <View style={styles.row}>
            <Text style={styles.labelCol}>Menimbang</Text>
            <Text style={styles.colonCol}>:</Text>
            <Text style={styles.numberCol}></Text>
            <Text style={styles.contentCol}>
              Bahwa dalam rangka penerapan Sistem Jaminan Mutu dan Keamanan Hasil 
              Perikanan yang tertuang dalam Peraturan Menteri Kelautan dan 
              Perikanan Nomor 10 Tahun 2021.
            </Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.labelCol}>Dasar</Text>
            <Text style={styles.colonCol}>:</Text>
            <Text style={styles.numberCol}></Text>
            <Text style={styles.contentCol}>
              Daftar Isian Pelaksanaan Anggaran Balai Pengendalian dan Pengawasan 
              Mutu Hasil Kelautan dan Perikanan Jakarta TA 2026 Nomor 
              DIPA: 032.13.2.649682/2026. Segala biaya yang timbul berkaitan 
              dengan pelaksanaan tugas dibebankan pada anggaran Balai Karantina 
              Ikan, Pengendalian Mutu, dan Keamanan Hasil Perikanan Jakarta II TA 2026
            </Text>
          </View>
        </View>

       
        <View style={[styles.row, { marginTop: 10 }]}>
          <Text style={styles.labelCol}>Kepada</Text>
          <Text style={styles.colonCol}>:</Text>
          
          <View style={styles.contentCol}>
            {isTerlampir ? (
        
              <Text>Daftar Nama Terlampir</Text>
            ) : (
              
              personil.map((item, idx) => (
                <View key={idx} style={{ marginBottom: 8 }}>
                  <View style={styles.row}>
                    <Text style={{ width: 15 }}>{idx + 1}.</Text>
                    <View style={{ flex: 1 }}>
                      <View style={styles.fieldRow}>
                        <Text style={styles.fieldLabel}>Nama</Text>
                        <Text style={styles.fieldColon}>:</Text>
                        <Text style={[styles.fieldValue, styles.Text]}>{item.nama} ({idx === 0 ? "Ketua" : "Anggota"})</Text>
                      </View>
                      <View style={styles.fieldRow}>
                        <Text style={styles.fieldLabel}>NIP</Text>
                        <Text style={styles.fieldColon}>:</Text>
                        <Text style={styles.fieldValue}>{item.nip}</Text>
                      </View>
                      <View style={styles.fieldRow}>
                        <Text style={styles.fieldLabel}>No Reg</Text>
                        <Text style={styles.fieldColon}>:</Text>
                        <Text style={styles.fieldValue}>{item.noreg}</Text>
                      </View>
                    </View>
                  </View>
                </View>
              ))
            )}
          </View>
        </View>


        <View style={[styles.row, { marginTop: 2}]}>
          <Text style={styles.labelCol}>Untuk</Text>
          <Text style={styles.colonCol}>:</Text>
          <Text style={styles.numberCol}>a.</Text>
          <View style={styles.contentCol}>
            <Text>Melaksanakan kegiatan Inspeksi Penerapan HACCP UPI di Provinsi {jadwalUtama.PROP} selama {getSelisihHari(jadwalUtama.TANGGAL, jadwalUtama.TANGGAL_KEMBALI)} hari pada tanggal {formatTanggal(jadwalUtama.TANGGAL)};</Text>
          </View>
        </View>
        <View style={styles.row}>
          <Text style={styles.labelCol}></Text>
          <Text style={styles.colonCol}></Text>
          <Text style={styles.numberCol}>b.</Text>
          <View style={styles.contentCol}>
            <Text>Membuat laporan tertulis atas pelaksaan tugas hasil inspeksi dan
                  melaporkannya kepada Kepala Pusat Mutu Pascapanen sesuai
                  ruang lingkup produk yang diinspeksi;</Text>
          </View>
        </View>
        {/* <View style={styles.row}>
          <Text style={styles.labelCol}></Text>
          <Text style={styles.colonCol}></Text>
          <Text style={styles.numberCol}>c.</Text>
          <View style={styles.contentCol}>
            <Text>Apabila pada saat  Survailen Penerapan Sistem HACCP dan Pengambilan Sampel Official Control pada Unit Pengolahan Ikan terdapat ruang lingkup produk yang  tidak  ada kegiatan proses, 
              maka ruang lingkup produk tersebut akan  diverifikasi  oleh  Inspektur  Mutu Balai Besar KIPM Jakarta I 
              dan selanjutnya dilaporkan  kepada  Kepala  Balai  Besar KIPM Jakarta I;</Text>
          </View>
        </View> */}
        <View style={styles.row}>
          <Text style={styles.labelCol}></Text>
          <Text style={styles.colonCol}></Text>
          <Text style={styles.numberCol}>c.</Text>
          <View style={styles.contentCol}>
            <Text style={styles.bold}>Inspektur Mutu tidak diperkenankan menerima sesuatu dari yang  akan  berpengaruh terhadap hasil Survailen Penerapan Sistem HACCP dan Pengambilan Sampel Official Control pada Unit Pengolahan Ikan.</Text>
          </View>
        </View>

        {/* PENUTUP */}
        <Text >
        {" "}{" "}{" "}Demikian Surat Tugas ini dibuat untuk dilaksanakan dengan sebaik-baiknya dan penuh tanggung jawab.
        </Text>


        {/* TTD */}
        <View style={styles.footerRow}>
        {/* KOTAK KKN */}
        <View style={styles.kknBox}>
          <Text style={styles.kknText}>
            Terima kasih untuk tidak memberikan sesuatu atau janji yang dapat mengakibatkan KKN, gratifikasi, dan benturan kepentingan
          </Text>
        </View>

        {/* TANDA TANGAN */}
        <View style={styles.ttd}>
          <Text>
           Jakarta, {formatTanggal(tanggal_surat)}
          </Text>

          <Text style={styles.jabatanText}>
           Plt. Kepala Balai Pengendalian dan Pengawasan Mutu Hasil Kelautan dan Perikanan Jakarta, 
          </Text>

          <Text style={styles.namaPejabat}>
            {pejabat_ttd}
          </Text>
        </View>
      </View>
        {/* <View >
          <Text style={{fontSize : 7, lineHeight: 0.8}} >
            Tembusan
          </Text>

          {[ 
            "Kepala Badan Pengendalian dan Pengawasan Mutu Hasil Kelautan dan Perikanan",
            "Kepala Pusat Pengendalian dan Pengawasan Mutu Pascapanen",
          ].map((item, index) => (
            <View
              key={index}
              style={{ fontSize: 7, flexDirection: "row", }}
            >
              <Text style={{ width: 14 }}>
                {index + 1}.
              </Text>
              <Text style={{ flex: 1 }}>
                {item}
              </Text>
            </View>
          ))}
        </View> */}

      </Page>
      {isTerlampir && (
        <LampPersonil data={data} personil={personil} />
      )}
      <LampProduk data={data} jadwal={jadwal} produk={produk} />
    </Document>
  );
};

export default STInspeksi;
